import { apiGet } from 'api';
import { DfiReportDocumentPathResponse } from 'types';

export const getDfiAnnualReportDocumentPath = (
  reportYear: number
): Promise<DfiReportDocumentPathResponse> =>
  apiGet<DfiReportDocumentPathResponse>(
    `reports/dfiAnnual/${reportYear}/sasTokenDocumentPath`
  );
